/**
 * @generated SignedSource<<7761be17fe6afb0e5301cccb892fd5d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type primaryContentItemContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "primaryContentItemContent";
};
export type primaryContentItemContent$key = {
  readonly " $data"?: primaryContentItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"primaryContentItemContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "primaryContentItemContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "6c34c3d9ed98a653adb3c5f546d3ae17";

export default node;
